import {Component} from '@wonderlandengine/api';
import {TriggerCollision} from '../trigger-collision.js';

/**
 * Base class for all actions.
 * To use, extend this class and override the OnTrigger.
 *
 * @requires TriggerAction to be on the same object.
 */
export class ActionBase extends Component {
    private triggerCollision?: TriggerCollision;

    start() {
        const tempTriggerAction = this.object.getComponent(TriggerCollision);
        if (!tempTriggerAction) {
            throw new Error(
                'Any Action component requires a TriggerAction component to be set on the same object.'
            );
        }
        this.triggerCollision = tempTriggerAction;
    }

    onActivate(): void {
        if (this.OnTrigger) {
            this.triggerCollision?.onTrigger.add(this.OnTrigger.bind(this));
        }
    }

    onDeactivate(): void {
        if (this.OnTrigger) {
            this.triggerCollision?.onTrigger.add(this.OnTrigger.bind(this));
        }
    }

    OnTrigger?(): void;
}
